import React from 'react'

import clsx from 'clsx'

import AuthorCard from 'components/AuthorCard'

import classes from './Authors.module.scss'

/** @type {import("./types").default} */
const Authors = ({ authors, className }) => {
  return (
    <div className={clsx('Authors', classes.root, className)}>
      {authors?.items?.map(author => (
        <React.Fragment key={`author-${author.authorName}`}>
          <span id={author.slug} className={classes.anchor} />
          <AuthorCard className={classes.item} author={author} tipText="About the author" />
        </React.Fragment>
      ))}
    </div>
  )
}

export default Authors
